import { gwGet } from '../../actions/actionsFactory/gwRequest';
import { setGetParams, handleGwData } from '../../actions/actionsFactory';
import API_PATH from '../../actions/actionsFactory/apiPath';

export const getStakingList = async () => {
  const result = await gwGet(
    `${API_PATH.STAKING_LIST}?${setGetParams({ pageNum: 1, pageSize: 100 })}`
  );
  return handleGwData(result);
};

// NOTE: This api call could be called by either server side or client side
export const getStakingDetail = async ({
  stakingId, isServer, req, locale,
}) => {
  const result = await gwGet(
    `${API_PATH.STAKING_DETAIL}?${setGetParams({ stakingId })}`,
    { locale },
    isServer ? req : null,
    true,
  );
  return handleGwData(result);
};

export const getStakingRebate = async ({ pageNum, pageSize }) => {
  const result = await gwGet(
    `${API_PATH.STAKING_REBATE}?${setGetParams({ pageNum, pageSize })}`
  );
  return {
    total: result.total,
    data: handleGwData(result),
  };
};

export const getStakingHoldHistory = async ({ assetName, pageNum = 1, pageSize = 50 }) => {
  const result = await gwGet(
    `${API_PATH.STAKING_HOLD_HISTORY}?${setGetParams({ asset: assetName, pageNum, pageSize })}`
  );
  return handleGwData(result);
};
